import React, {Proptype, Component} from 'react'
import classnames from 'classnames'
import {connect} from 'react-redux'
import { Table } from 'components/UI'
import {browserHistory} from 'react-router'
import {confirm} from 'util/confirm'
import {alert} from 'util/alert'

import './ClassroomTable.scss'

const mapStateToProps = (state) => ({

})


class ClassroomTable extends Component {
  constructor(props){
    super(props)
  }

  render(){

    let {tableData, settings, pagination, onItemsCountPerPageChange, onPageChange} = this.props
    
    const fields = [{
      name: "name",
      title:  __('Classroom Name', 'classroom')
    }]

    const CONTROLLER_WIDTH = '200px'

    return(
      <Table
        data={tableData}
        fields={fields}
        className='teacher-table'
        settingThTitle={__('Settings', 'class', null, true)}
        settingWidth={CONTROLLER_WIDTH}
        settings={settings}
        useMultiSelection={false}
        oneSettingPerRow={false}

        dropdownGuideWidth={160}
        dropdownGuideHeight={228}

        usePagination={true}
        pagination={pagination}
        onItemsCountPerPageChange={onItemsCountPerPageChange}
        onPageChange={onPageChange}
      />
    )
  }
}


export default connect(mapStateToProps)(ClassroomTable)



// WEBPACK FOOTER //
// ./src/containers/pages/Classroom/ClassroomTable/index.js